// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V11H22V2ZM7.00391 5.5L7.00391 7.50391H5V5.5H7.00391ZM11.0039 5.5L11.0039 7.50391H9V5.5H11.0039Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13H2V22H22V13ZM7.00391 16.5V18.5039H5V16.5H7.00391ZM11.0039 18.5039H9V16.5H11.0039V18.5039Z"}}]};

const SystemApplicationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-application-filled',
    ref,
    icon: element,
  },
));

SystemApplicationFilledIcon.displayName = 'SystemApplicationFilledIcon';

export default SystemApplicationFilledIcon;
